// extracted by mini-css-extract-plugin
module.exports =  {"versionCharts":"CiKBBxAlLw4BNXAItQ0q"};